import React, { useContext, useEffect, useState } from 'react'
import AppContext from '../../Context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import UserService from '../../common/util/UserService';
import { refershModule, Socket } from '../../Context/AppActions';
import AwsServerService from '../../common/util/AwsServerService';
import swal from "sweetalert";
import { GlobalAgGridTable } from '../Deal/AgGridReactComponent/GlobalAgGridTable';
import { Button, message } from 'antd';
import './UserRole.css'
import { NewCustomePopover } from '../TaskBluePrints/HelperComponents/NewCustomePopover';
import RolesPopupData from '../Roles/RolesPopupData';
import { setRefershModule } from '../../Context/ReduxContext';
import { canAccess } from '../../common/util/appUtils';

export const UserRole = ({ history, location }) => {
    const AppData = useContext(AppContext);
    const accessContext = useSelector(state => state.UserContext.accessContext);
    const { dispatch, state } = AppData || {};
    const AppReduxContext = useSelector((state) => state.AppReduxContext);
    const AllDeals = useSelector((state) => state.AppReduxContext.AllDeals);
    const moduleContact = useSelector((state) => state.AppReduxContext.moduleContacts);
    const ModuleTab = useSelector((state) => state.AppReduxContext.ModuleTab);
    const AllModuleUsers = useSelector((state) => state.AppReduxContext.AllModuleUsers);
    const RefershModule = useSelector((state) => state.AppReduxContext.refershModule)
    const dispatchRedux = useDispatch();

    const defaulRoleState = { open: false, module: "", data: null, type: "create" };
    const [openRoleModal, setOpenRoleMadal] = useState({ open: false, module: "", data: null, type: "create" });

    const [allUserRoles, setAllUserRoles] = useState([])
    const [allCacheUserRoles, setAllCacheUserRoles] = useState([])
    const [allUsers, setAllUsers] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [view, setView] = useState();
    const [allRoles, setAllRoles] = useState([])
    const [allCacheRoles, setAllCacheRoles] = useState([])

    const [errorPopConfirm, setErrorPopConfirm] = useState();

    const [projectRoleObject, setprojectRoleObject] = useState({
        "RoleId": "",
        "UserId": "",
        "UserType": "",
    })


    const fetRoles = () => {
        AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
            setAllRoles(res.data);
            setAllCacheRoles(res.data);
        }).catch(err => {
            console.log(err);
        })
    }
    const fetUserRoles = () => {
        AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "USERROLES" }).then(res => {
            setAllUserRoles(res.data.reverse());
            setAllCacheUserRoles(res.data.reverse());
        }).catch(err => {
            console.log(err);
        })
    }
    useEffect(() => {
        fetRoles();
        fetUserRoles();
    }, [])

    useEffect(() => {
        UserService.GetAllUsers().then(r => {
            setAllUsers(r.data.users)
        })
    }, [])
    useEffect(e => {
        if (AllDeals) {
            setAllProjects(AllDeals);
        }
    }, [AllDeals])
    useEffect(e => {
        if (RefershModule?.module == "Roles") {
            fetRoles();
            dispatchRedux(setRefershModule(null))
        }
        if (RefershModule?.module == "UserRoles") {
            fetUserRoles();
            dispatchRedux(setRefershModule(null))
        }
    }, [RefershModule])
    useEffect(e => {
        if (ModuleTab && ModuleTab.tab) {
            setView(ModuleTab.tab);
        }
    }, [AppReduxContext])

    const actionListCellRenderer = (params) => {
        // console.log(params);
        const canEdit = canAccess(accessContext, "User Roles Assignments", "Edit")
        const canDelete = canAccess(accessContext, "User Roles Assignments", "Delete")
        let btnDiv = document.createElement("div");
        btnDiv.classList.add("global-action-btn-for-tables");

        let editBtn = document.createElement('button');
        editBtn.classList.add("add")
        editBtn.innerText = "Edit"
        editBtn.id = params.ROWID;
        editBtn.addEventListener('click', (e) => {
            if(!canEdit){
                message.error("Permission Denied.");
                return;
            }
            let Rowid = e.currentTarget.id;
            if (params.ROWID == Rowid) {
                // if (params && view !== "roles") {
                // params = { ...params, RoleId: "Roles_" + params.RoleId};
                setprojectRoleObject(params);
                // }
                setOpenRoleMadal({ open: true, data: { ...params }, module: "userroles", type: "edit" });
            }
        })
        let deleteBtn = document.createElement('button');
        deleteBtn.classList.add("add")
        deleteBtn.style.color = "red";
        deleteBtn.innerText = "Delete";
        deleteBtn.id = params.ROWID;
        deleteBtn.addEventListener('click', (e) => {
            if(!canDelete){
                message.error("Permission Denied.");
                return;
            }
            let Rowid = e.currentTarget.id;
            swal({
                title: "Warning!",
                text: `Are you sure you want to delete the ${view == "roles" ? "Role" : "User Role"}?`,
                icon: "warning",
                buttons: {
                    cancel: "Cancel",
                    confirm: "Proceed",
                },
            }).then(async (isDelete) => {
                if (isDelete) {
                    AwsServerService.CrudServiceHandler({ method: "DELETE", data: {ROWID: Rowid}, route: "USERROLES" }).then(res => {
                        dispatch(Socket({ trigger: "Refresh_Module", data: "UserRoles" }))
                    })
                }
            })
        })
        btnDiv.appendChild(editBtn);
        btnDiv.appendChild(deleteBtn);
        return btnDiv;
    }
    const navigateToProject = (params) => {
        let role = allCacheRoles?.find(k => k.ROWID == params.RoleId);
        let keyData = params.ProjectId;

        if (params.UserType == "Deal") {
            const eDiv = document.createElement("div");
            eDiv.innerHTML = `<div class="btn-group deal-status-dropdown-custom deal-status-dropdown-custom-name">
                <button type="button" style="background-color:#5b6c97"  class="btn btn-sm dropdown-toggle underline-icon" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="visually-hidden">${keyData}</span>
                </button>
                <ul  class="dropdown-menu">
                   <li class="status-deal"><a class="dropdown-item" ></a></li>
                </ul>
              </div>
              `;
            return eDiv;

        } else if (params.UserType == "Account") {
            let account = AllModuleUsers["Accounts"]?.find(a => a.value == params.ProjectId)
            const eDiv = document.createElement("div");
            eDiv.innerHTML = `<div class="btn-group deal-status-dropdown-custom deal-status-dropdown-custom-name">
                <button type="button" style="background-color:#5b6c97"  class="btn btn-sm dropdown-toggle underline-icon" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="visually-hidden">${account?.label}</span>
                </button>
                <ul  class="dropdown-menu">
                   <li class="status-deal"><a class="dropdown-item" ></a></li>
                </ul>
              </div>
              `;
            if (account)
                return eDiv;
        } else if (params.UserType == "Vendor") {
            let Vendor = AllModuleUsers["Vendors"]?.find(a => a.value == params.ProjectId)
            const eDiv = document.createElement("div");
            eDiv.innerHTML = `<div class="btn-group deal-status-dropdown-custom deal-status-dropdown-custom-name">
                <button type="button" style="background-color:#5b6c97"  class="btn btn-sm dropdown-toggle underline-icon" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="visually-hidden">${Vendor?.label}</span>
                </button>
                <ul  class="dropdown-menu">
                   <li class="status-deal"><a class="dropdown-item" ></a></li>
                </ul>
              </div>
              `;
            if (Vendor)
                return eDiv;
        } else {
            const eDiv = document.createElement("div");
            eDiv.innerHTML = `<div class="btn-group deal-status-dropdown-custom deal-status-dropdown-custom-name">
                <button type="button" style="background-color:#5b6c97"  class="btn btn-sm dropdown-toggle underline-icon" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="visually-hidden">N/A</span>
                </button>
                <ul  class="dropdown-menu">
                   <li class="status-deal"><a class="dropdown-item" ></a></li>
                </ul>
              </div>
              `;
            return eDiv
        }
        // if(role.RoleType == "Deal"){

        // }else{
        //     return keyData;
        // }

    };
    const userRoleCols = [
        {
            field: "ProjectId",
            name: "Associated ID",
            path: "ProjectId",
            type: "text",
            key: "UserId",
            label: "UserId",
            id: 0,
            isChecked: false,
            isDragOver: false,
            isSearch: true,
            content: (obj) => {
                return navigateToProject({ ...obj })
            }
        },
        {
            field: "UserId",
            name: "User",
            path: "UserId",
            type: "text",
            key: "UserId",
            label: "UserId",
            id: 1,
            isChecked: false,
            isDragOver: false,
            isSearch: true,
            content: (obj) => {

                let type = obj.UserType;
                if (type == "Zoho") {
                    return allUsers.find(k => k.zuid == obj.UserId)?.full_name;
                } else if (type === 'Deal') {
                    let DealUser = null;
                    const moduleContacts = moduleContact || {};

                    for (const Type of Object.keys(moduleContacts)) {
                        if (Type === 'Internal') {
                            const foundUser = moduleContacts[Type]?.find((a) => a.id === obj?.UserId);
                            if (foundUser) {
                                DealUser = foundUser;
                                break; // Stop looping once found
                            }
                        }
                    }
                    if(!DealUser?.name){
                        let user = Object.values(moduleContact || {}).flat()?.find(k => k.id == obj.UserId);
                        return user?.Full_Name;
                    }else{
                        return DealUser?.name || "N/A";
                    }

                    
                } else {
                    // if(!type.endsWith("s")){
                    //     type+="s";
                    // }
                    let user = Object.values(moduleContact || {}).flat()?.find(k => k.id == obj.UserId);
                    return user?.Full_Name;
                }
            },
        },
        {
            field: "UserType",
            name: "Role Type",
            path: "UserType",
            type: "text",
            key: "UserId",
            label: "UserId",
            id: 2,
            isChecked: false,
            isDragOver: false,
            isSearch: true,
            content: (obj) => {
                let name = allCacheRoles?.find(k => k.ROWID == obj.RoleId)?.RoleType;
                return name;
            },
        },
        {
            field: "RoleId",
            name: "Role Name",
            path: "RoleId",
            key: "RoleId",
            type: "text",
            label: "Role Name",
            id: 3,
            isChecked: false,
            isDragOver: false,
            isSearch: true,
            content: (obj) => {
                let name = allCacheRoles.find(k => k.ROWID == obj.RoleId)?.RoleName;
                return name;
            },
        },
        {
            field: "Action",
            key: "Action",
            name: "Action",
            path: "Action",
            type: "text",
            label: "Action",
            id: 4,
            isChecked: false,
            isDragOver: false,
            isSearch: true,
            content: actionListCellRenderer,
        },
    ];
    const extraComponentToRightForUserRole = (e) => {
        return (
            <div className="extra-component-request-toRight">
                <div className="job-action-box">
                    <Button
                        style={canAccess(accessContext, "User Roles Assignments", "Create") ? {} : {opacity: 0.2, pointerEvents: "none", cursor: "not-alloweds"}}
                        type='primary'
                        className="mr-3 request-btns"
                        onClick={() => {
                            setOpenRoleMadal({ module: "userroles", data: null, open: true, type: "create" });
                        }}
                    >
                        Assign Role
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className='UserRoles-Wrapper'>
            <RolesPopupData
                onCloseRoleModal={() => {
                    setprojectRoleObject({
                        "RoleId": "",
                        "UserId": "",
                        "UserType": "",
                    })
                    setOpenRoleMadal(defaulRoleState)
                }}
                openRoleModal={openRoleModal}
                onSaveCallBack={data => {
                    setprojectRoleObject({
                        "RoleId": "",
                        "UserId": "",
                        "UserType": "",
                    })
                    dispatch(Socket({ trigger: "Refresh_Module", data: "UserRoles" }));
                }}
                setprojectRoleObject={setprojectRoleObject}
                projectRoleObject={projectRoleObject}
            // onCloseRoleModal={onCloseRoleModal}
            />
            <NewCustomePopover
                width={30}
                open={errorPopConfirm}
                title={"Warning!"}
                okText={"Confirm"}
                cancelText={"Cancel"}
                onCancel={e => {
                    setErrorPopConfirm(null)
                }}
                onOk={e => {
                    setErrorPopConfirm(null)
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <div className='Msg-Block'>
                    {errorPopConfirm}
                </div>
            </NewCustomePopover>
            <div style={{ width: "100%", height: "79%" }}>
                <div id="myGrid" className='ag-theme-alpine Blueprint-Body'>
                    <GlobalAgGridTable
                        headers={userRoleCols}
                        setRowData={setAllUserRoles}
                        cacheRowData={allCacheUserRoles}
                        setCacheRowData={setAllCacheUserRoles}
                        module="UserRoles"
                        mainUrl="UserRoles"
                        // DropDownFields={["User Name", "Check In", "Check Out"]}
                        rowData={allUserRoles}
                        renderExtraComponent={() => <></>}
                        renderExtraComponentToRight={extraComponentToRightForUserRole}
                        isTaskFilterHide={true}
                    />
                </div>
            </div>
        </div>
    )
}
